import { useGlobalSurveysProvider } from "../../contexts/global-surveys.context";
import { useUserAuth } from "../../contexts/user.context";

const useUpdateSurveyData = () => {
    const { exampleSurveys,
        setExampleSurveys,
        userSurveyHistory,
        setUserSurveyHistory,
        userSurveyHistoryLoaded,
    } = useGlobalSurveysProvider();

    const { currentUser } = useUserAuth();

    const userId = currentUser ? currentUser.uid : 'anon';

    const updateSurveyData = async (newSurveyData) => {
        // update user data in firebase
        await fetch("/.netlify/functions/updateSurveyData", { method: "POST", body: JSON.stringify({ newSurveyData, userId }) });

        // If survey in surveyHistory, update it
        if (userSurveyHistoryLoaded) {
            const isHistorySurvey = userSurveyHistory.some((survey) => survey.id === newSurveyData.id);
            if (isHistorySurvey) {
                const newSurveyHistory = userSurveyHistory.map((survey) => {
                    if (survey.id === newSurveyData.id) {
                        console.log('survey id found')
                        return newSurveyData;
                    }
                    return survey;
                });
                setUserSurveyHistory(newSurveyHistory);
            }
        }

        // If survey in exampleSurveys, update it
        const isExampleSurvey = exampleSurveys.some((survey) => survey.id === newSurveyData.id);
        if (isExampleSurvey) {
            const newExampleSurveys = exampleSurveys.map((survey) => {
                if (survey.id === newSurveyData.id) {
                    return newSurveyData;
                }
                return survey;
            });
            setExampleSurveys(newExampleSurveys);
        }
    };

    return updateSurveyData;
};

export default useUpdateSurveyData;